/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */


import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminSpamClassifierService {

  constructor(private http: HttpClient) { }

  getSpamTraining(type:string, category: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/spamclassifier/training/${type}/${category}`
      );
  }

  newSpamTraining(type: string, model: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/spamclassifier/training/${type}`,
        JSON.stringify(model)
      );
  }

  updateSpamTraining(id: string, type: string, content: string, language: string): Observable<any> {
    return this.http
      .put(
        `/api/v1/admin/spamclassifier/training/${type}/${id}`,
        JSON.stringify({ content: content, language: language })
      );
  }

  deleteSpamTraining(id: string, type: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/spamclassifier/training/${type}/${id}`
      );
  }

}


// WEBPACK FOOTER //
// ./client/app/services/admin/admin-spamclassifier.service.ts